module.exports = __webpack_public_path__ + "img/u4672.607ebe2e.svg";